import { useState, useEffect } from "react";

const sections = ["hero", "experience", "projects", "about", "contact"];

export const sectionConfig = {
  hero: { label: "", color: "text-blue-600", textClass: "text-blue-600" },
  experience: {
    label: "Experience",
    color: "text-orange-600",
    textClass: "text-orange-600",
  },
  projects: {
    label: "Projects",
    color: "text-blue-600",
    textClass: "text-blue-600",
  },
  about: {
    label: "About",
    color: "text-purple-600",
    textClass: "text-purple-600",
  },
  contact: {
    label: "Contact",
    color: "text-green-600",
    textClass: "text-green-600",
  },
};

export function useActiveSection() {
  const [activeSection, setActiveSection] = useState("hero");

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight / 3;
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections[i]);
        if (el && el.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return activeSection;
}
